export default {
  locales: {
    it: {
      validation: {
        required() {
          return `Il campo è richiesto`
        },
        email() {
          return `Il campo non è valido`
        },
      },
    },
    en: {
      validation: {
        required() {
          return `The field is required`
        },
        email() {
          return `The field is invalid`
        },
      },
    },
    es: {
      validation: {
        required() {
          return `El campo es obligatorio`
        },
        email() {
          return `El campo no es válido`
        },
      },
    },
    fr: {
      validation: {
        required() {
          return `Le champ est requis`
        },
        email() {
          return `Le champ n'est pas valide`
        },
      },
    },
  },
  locale: 'it',
}
